export default "__VITE_ASSET__Czp5P2u$__"